// Module-scoped endpoint paths for offering detail.
// Listing/filter/bookmark live in the offerings/browse sub-module.

export const PROPERTY_ENDPOINTS = {
  PROPERTY_DETAIL: '/api/offerings/{offeringId}',
  // POST subscribes, DELETE unsubscribes — launch alert for Launching Soon.
  NOTIFY_ME: '/api/offerings/{offeringId}/notify',
} as const
